import React from 'react'
import { css } from '@emotion/core'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type Props = {
  id?: string
}

export const SelfCheckinContentCard: React.FC<Props> = ({ children, id }) => (
  <div id={id} css={cardStyle}>
    {children}
  </div>
)

const cardStyle = css(
  {
    boxSizing: 'border-box',
    width: '100%',
    padding: 40,
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
  },
  createSelfCheckinResponsiveStyle({
    portrait: { borderRadius: 0 },
  }),
)
